import Styles from 'src/components/Styles';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

export function getStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    gradientBackground: {
      flex: 1,
    },
    title: {
      fontWeight: '400',
      fontSize: getLayoutDescriber().subHeaderFontSize(),
      textAlign: 'center',
      color: Styles.Colors.PayNew.black01,
    },
    youGotText: {
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '400',
      textAlign: 'center',
      color: Styles.Colors.PayNew.black01,
      lineHeight: 20,
    },
    amount: {
      fontSize: Styles.Fonts.f6 - 3.34,
      fontWeight: '700',
      paddingVertical: Styles.Spacing.m3,
      textAlign: 'center',
    },
    text: {
      color: Styles.Colors.PayNew.black01,
      fontSize: getLayoutDescriber().bodyFontSize(),
      textAlign: 'center',
      fontWeight: '400',
    },
    buttonStyle: {
      marginTop: 60,
      alignSelf: 'center',
      justifyContent: 'center',
    },
    hometext: {
      textAlign: 'center',
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '700',
    },
  };
}

export default {
  getStyleDescriptor,
};
